import { SET_PORTAL_API } from "./portal_actions";
import { START_LOADING, END_LOADING } from "./loading_actions";
import {
  TEXT_SET_EMAIL_SUCCESS, TITLE_NOTIFICATION, TITLE_ERROR
} from "../../utils/constants";
import { postSetEmail } from "../../utils/api";

export const SET_EMAIL_EDIT_CP = 'SET_EMAIL_EDIT_CP';
export const SET_EMAIL_EDIT_NE = 'SET_EMAIL_EDIT_NE';
export const SET_EMAIL_EDIT_RNE = 'SET_EMAIL_EDIT_RNE';
export const SET_EMAIL_CLEAR_FORM = 'SET_EMAIL_CLEAR_FORM';



export const postSetEmailThunk = (accessToken, refreshToken,
  data
) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING });
    postSetEmail(accessToken, refreshToken, data)
      .then(data => {
        dispatch({ type: SET_EMAIL_CLEAR_FORM });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_SET_EMAIL_SUCCESS
        });
      })
      .catch(error => {
        console.log('error =', error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
